export default "/assets/website/images/email.svg?bc5a25d73d88bce3aeb86c0a4c7a285c";